import { Payment } from '@mews-commander/types';
import { TagVariant } from '@optimus-web/core';
import { PaymentState, PaymentType, AlternativePaymentMethod } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';

const mapPaymentStateToTextKey: Record<PaymentState, Mews.TextKey> = {
    [PaymentState.Canceled]: TextKey.PaymentStateCanceled,
    [PaymentState.Charged]: TextKey.PaymentStateCharged,
    [PaymentState.Failed]: TextKey.PaymentStateFailed,
    [PaymentState.Pending]: TextKey.PaymentStatePending,
    [PaymentState.Verifying]: TextKey.PaymentStateVerifying,
};

const mapPaymentStateToVariant: Record<PaymentState, TagVariant> = {
    [PaymentState.Failed]: 'danger',
    [PaymentState.Canceled]: 'basicBold',
    [PaymentState.Charged]: 'primary',
    [PaymentState.Pending]: 'primary',
    [PaymentState.Verifying]: 'primary',
};

const isSepaPaymentMethod = ({ discriminator, value }: Payment['data']) =>
    discriminator === PaymentType.Alternative && value.data.discriminator === AlternativePaymentMethod.SepaDirectDebit;

export const getPaymentStateTagProps = ({ state, data }: Payment): { textKey: Mews.TextKey; variant: TagVariant } => {
    if (state === PaymentState.Verifying && isSepaPaymentMethod(data)) {
        return {
            textKey: TextKey.PaymentStateWithBank,
            variant: 'primary',
        };
    }
    return {
        textKey: mapPaymentStateToTextKey[state],
        variant: mapPaymentStateToVariant[state],
    };
};

export const isWithBankSepaPaymentMethod = ({ state, data }: Payment) =>
    state === PaymentState.Verifying && isSepaPaymentMethod(data);
